import Vue from 'vue';
import VueI18n from 'vue-i18n';
import locale from 'element-ui/lib/locale';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import zhCn from '@/i18n/zhCn';
import en from '@/i18n/en';
Vue.use(VueI18n);
var messages = {
  en: Object.assign(en, enLocale),
  zh: Object.assign(zhCn, zhLocale)
};
var language = window.localStorage.getItem('language') ? window.localStorage.getItem('language') : 'zh';
var i18n = new VueI18n({
  locale: language,
  messages: messages
});
window.$i18n = i18n;
locale.i18n(function (key, value) {
  return i18n.t(key, value);
});
export default i18n;